import AccessLevelMixin from '@/core/application-dictionary/mixins/AccessLevelMixin';
import { AccountStoreModule } from '@/shared/config/store/account-store';
import { debounce } from 'lodash';
import { Component, Inject, Mixins, Vue, Watch } from 'vue-property-decorator';
import ChatRoomService from './chatroom.service';
import DynamicWindowService from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service';
import moment from 'moment';
import Attachment from './components/attachment.vue';

const adUserApi= "api/ad-users";
const mChatApi= "api/m-chats";
const mChatRoomApi= "api/m-chat-rooms";
const mChatRoomParticipantApi= "api/m-chat-room-participants";

const role_vendor= "ROLE_SUPPLIER";
const role_chat= "ROLE_CHAT";

const single_chat_room="SINGLE";
const group_chat_room="GROUP";

const ChatRoomProp= Vue.extend({
    props: {
        displayChat: {
            type: Boolean,
            default: () => false
        }
    }
});

@Component({
    components: {Attachment}
})
export default class ChatRoom extends Mixins(ChatRoomProp, AccessLevelMixin) {

    @Inject("dynamicWindowService")
    private commonService: (baseApiUrl: string) => DynamicWindowService;

    _displayChat: boolean= false;
    viewChatRoom: boolean= false;

    chatText: string= "";
    recieverName: string="User supervisor";
    formModel: any= {
        chatText: ""
    }

    currentUser: string= AccountStoreModule.context.getters.account.login;
    currentUserId: number= parseInt(AccountStoreModule.context.getters.account.id);

    chatRoomService: ChatRoomService= null ;
    // debounceRefresh: (data: any)=> void;
    debounceLoadChatList: ()=> void;
    debounceLoadUserList: ()=> void;

    chats: Array<any>= [];

    chatUsers: Array<any>= [];

    chatRooms: Array<any>= [];
    chatRoom: any= null;

    loadingChatList: boolean= false;

    // viewSelectUsers: boolean= false;
    loadingUserList: boolean= false;

    selectUserType: String= "SINGLE";

    selectedUsers: any[] = [];

    page: number= 1;

    userForm: any= {
        groupName: "",
        searchVendor: ""
    }

    openUploadDocument: boolean= false;

    @Watch("displayChat")
    onDisplayChatChange(displayChat: boolean): void {
        // console.log(displayChat);
        if(this.displayChat) {
            this._displayChat=  true;
            this.retrieveUsers();
        }else {
            this._displayChat= false;
        }
    }

    created(): void{
        this.chatRoomService= new ChatRoomService(this);
        // this.debounceRefresh= debounce(this.refresh, 500);
        this.debounceLoadChatList= debounce(this.loadChatList, 1000);
        this.debounceLoadUserList= debounce(this.retrieveUsers, 1000);
    }

    async retrieveChatRooms(): Promise<void>{

        /**
         * TODO
         * instead retriving chat room, retrieve chat room participant with current user id
         * for chat room participant bind chat room data like chat room name, id, and active status = true
         * add filter query for chat room participant to chat room active status
         */
        this.loadingChatList= true;

        // let chatRoomIds: number[]=
        //     await this.commonService(mChatRoomParticipantApi)
        //             .retrieve({
        //                 criteriaQuery: [`adUserId.equals=${this.currentUserId}`]
        //             }).then(res=> {
        //                 return res.data.map(o=> parseInt(o.chatRoomId));
        //             });
        // if(chatRoomIds.length === 0) {
        //     this.loadingChatList= false;
        //     return ;
        // }

        this.commonService(mChatRoomParticipantApi)
            .retrieve({
                criteriaQuery: [`adUserId.equals=${this.currentUserId}`, 'roomActive.equals=true']
            }).then(res=> {
                this.chatRooms= res.data;
            }).finally(()=> this.loadingChatList= false);

        /**
         * this part should be skipped since chat room information is already retrieve from chat room
         * participant data
         */
        // this.commonService(mChatRoomApi)
        //             .retrieve({
        //                 criteriaQuery: [`id.in=${chatRoomIds}`, 'active.equals=true']
        //             }).then(res=> {
        //                 this.chatRooms= res.data;
        //             }).finally(()=> this.loadingChatList= false);
    }

    openSelectUser(type: string): void {
        this.page= 3;

        // document.getElementsByClassName("v-modal")[0].remove();
        this.selectUserType= type;

        this.retrieveUsers();
    }

    onUserSelectionChage(rows: any[]): void {
        if(this.selectUserType === "GROUP")this.selectedUsers= rows;
    }

    onUserChange(row: any): void {

        if(this.selectUserType === "SINGLE") this.selectedUsers=[row];
    }

    getRoomName(room: any): string{
        if(room.type === "GROUP") return room.groupName;
        if(room.type === "SINGLE") {
            return room.singleName;
        }
    }

    createRoom(): void {
        let type= this.selectedUsers.length == 1 ? 'SINGLE' : 'GROUP';

        if(type === 'GROUP' && this.userForm.groupName === ""){
            this.$message.warning("Please input group name !");
            return ;
        }

        let name= type === 'GROUP' ? this.userForm.groupName : this.userDisplayName(this.selectedUsers[0]) + ' - ' + this.currentUser;

        // let singleName=this.userDisplayName(this.selectedUsers[0]) + ' - ' + this.currentUser;
        let room= {
            type : type,
            groupName: name,
            singleName: name,
            active: true
        }

        this.commonService(mChatRoomApi).create(room)
            .then( res=> {
                // open chat room
                // this.connectWebSocket(res.data.id);

                // create participant
                this.createParticipant(res);
            })
            .catch(e=> {
                this.$message.error("Fail to create room : " + e.message);
            })
    }

    async createParticipant(room): Promise<void> {

        let selectedUserId: Array<any>= this.selectedUsers.map(u=> u.id);

        if(!selectedUserId.includes(this.currentUserId)){
            this.selectedUsers.push({
                id : this.currentUserId
            });
        }


        for(let x=0; x< this.selectedUsers.length; x++) {
            await this.commonService(mChatRoomParticipantApi)
                .create({
                    adUserId : this.selectedUsers[x].id,
                    chatRoomId: room.id
                }).then(res=> {
                    this.sendMail(room.id, "open_chat");
                });
        }

        this.openChat(room);
    }

    mounted(): void{
        // console.log("do mounting");
        this.retrieveChatRooms();
    }

    connectWebSocket(roomId): void {
        this.chatRoomService.connect(roomId);
        // this.chatRoomService.subscribe();
        this.chatRoomService.receive().subscribe((data)=> {
            // console.log("on recieve messages");
            this.refresh(data);
        });
    }

    beforeDestroy(): void{
        this.chatRoomService.unsubscribe();
    }

    async retrieveUsers(): Promise<void> {
        let searchRole= [];

        if(this.isVendorUser()) {
            searchRole.push(role_chat);
        }else if(this.isChatUser()) {
            searchRole.push(role_vendor);
        }

        this.loadingUserList= true;

        let paginationQuery= {
            page: 0,
            size: 500,
            sort: ['cVendor.id']
        }

        let userByVendor:any[]=[];

        let baseCriteriaQuery= [];
        if(!!this.userForm.searchVendor){
            baseCriteriaQuery.push(`cVendorName.contains=${this.userForm.searchVendor}`);
        }

        let userByRole=
            await this.commonService(adUserApi)
            .retrieve({
                criteriaQuery : [`authorityName.in=${searchRole}`].concat(baseCriteriaQuery),
                paginationQuery
            }).then(res=> {
                return res.data
                // this.chatUsers= res.data;
            })
            // .finally(()=> this.loadingUserList= false);

        if(this.isVendorUser()) {
            let vendorId= AccountStoreModule.context.getters.vendorInfo.id
            userByVendor=
                await this.commonService(adUserApi)
                    .retrieve({
                        criteriaQuery : [`cVendorId.equals=${vendorId}`].concat(baseCriteriaQuery),
                        paginationQuery
                    })
                    .then(res=> {
                        return res.data
                    })
        }

        this.chatUsers= [
            ...userByRole,
            ...userByVendor
        ].filter(u=> u.id != this.currentUserId);

        this.loadingUserList= false;

    }

    isVendorUser(): boolean {
        let userAuth: any[]= AccountStoreModule.context.getters.account.authorities;
        return userAuth.includes(role_vendor);
    }

    isChatUser(): boolean {
        return AccountStoreModule.context.getters.account.authorities.includes(role_chat);
    }

    refresh(data): void {

        if(data.chatRoomId === this.chatRoom.id) {
            this.debounceLoadChatList();
        }
    }

    openChat(room: any): void {
        this.chatRoom= room;
        this.page = 2;
        this.recieverName= this.getRoomName(room);
        //TODO  this mark read all message must do after retrieve chat list 
        // this.markReadAllMessage();
        this.connectWebSocket(room.id);
        this.loadChatList();
    }

    closeRoom(): void {
        this.page= 1;
        this.chatRoomService.unsubscribe();
        // this.markReadAllMessage();
        this.retrieveChatRooms();
    }

    loadChatList(): void {

        if(this.chatRoom == null) return ;

        let paginationQuery= {
            page: 0,
            size: 50,
            sort: ['id,desc']
        }

        this.commonService(mChatApi)
            .retrieve({
                criteriaQuery: [`chatRoomId.equals=${this.chatRoom.id}`]
                ,paginationQuery
            }).then(res=> {
                this.chats= res.data.sort((a, b)=> {
                    return Number(a.id) - Number(b.id);
                });
                this.markReadAllMessage();

            }).finally(()=> {
                let container= document.getElementById('chat-list-container');
                container.scrollTop= container.scrollHeight;
            });

    }

    formatTime(time): string {
        return moment(time).format("DD/MM/YYYY hh:mm");
    }

    userDisplayName(user: any): string {

        return user.userLogin;
    }

    async sendMessage():Promise<void> {
        // create chat data

        let message= {
            chatRoomId : this.chatRoom.id,
            senderId: this.currentUserId,
            recieverId: this.currentUserId,
            message: this.formModel.chatText,
            timeSend: new Date(),
            type: "TEXT"
        }

        this.doSendMessage(message);
        // await this.commonService(mChatApi)
        //     .create()
        //     .then(res=> {
        //         this.chatRoomService.sendMessage(res);
        //         this.formModel.chatText="";
        //     });

        // let chatRoomId= this.chatRoom.id;
        // let participants: any[] =
        // await this.commonService(mChatRoomParticipantApi)
        //     .retrieve({
        //         criteriaQuery: [`chatRoomId.equals=${chatRoomId}`]
        //     }).then(res=> {
        //         return res.data;
        //     })

        // for(let x= 0; x< participants.length; x++){
        //     let paticipant= participants[x];

        //     paticipant.unreadMessage= Number(paticipant.unreadMessage) + 1 ;
        //     await this.commonService(mChatRoomParticipantApi)
        //         .update(paticipant)
        //         .then(()=> {});
        // }
    }

    async doSendMessage(message: any):Promise<void> {
        await this.commonService(mChatApi)
            .create(message)
            .then(res=> {
                this.chatRoomService.sendMessage(res);
                this.formModel.chatText="";
            });

        let chatRoomId= this.chatRoom.id;
        let participants: any[] =
        await this.commonService(mChatRoomParticipantApi)
            .retrieve({
                criteriaQuery: [`chatRoomId.equals=${chatRoomId}`]
            }).then(res=> {
                return res.data;
            })

        for(let x= 0; x< participants.length; x++){
            let paticipant= participants[x];

            paticipant.unreadMessage= Number(paticipant.unreadMessage) + 1 ;
            await this.commonService(mChatRoomParticipantApi)
                .update(paticipant)
                .then(()=> {});
        }
    }

    markReadAllMessage(): void {

        if(this.chatRoom == null) return ;

        let roomId= this.chatRoom.id;
        this.commonService(`${mChatRoomParticipantApi}/update-read-message/${roomId}/${this.currentUserId}`)
            .retrieve().then(()=> {});
    }

    closeChatRoom(): void {

        //console.log("closing chat room");
        this.$emit('close');
    }

    async sendMail(roomId, type):Promise<void> {
        // get ad table id
        let tableId= await this.commonService("api/ad-tables")
            .retrieve({
                criteriaQuery: ['name.equals=m_chat_room']
            }).then(res=> {
                return res.data[0].id;
            });

        let recipients:any[]= await this.commonService(mChatRoomParticipantApi)
            .retrieve({
                criteriaQuery:  [`chatRoomId.equals=${roomId}`]
            }).then(res=> {
                return res.data;
            });

        this.commonService(`${mChatRoomParticipantApi}/send-mail`)
            .create({
                type : type,
                participants : recipients,
                roomId: roomId,
                tableId: tableId
            }).then(()=>{});
    }

    async removeRoom(room): Promise<void> {
        room.active= false;

        await this.commonService(mChatRoomApi)
                .update(room)
                .then(()=>{});

        await this.sendMail(room.id, "close_chat");
        await this.retrieveChatRooms();
    }

    openDocumentDialog(): void {
        this.openUploadDocument= true;
        // document.getElementById("open-select-document").focus();
        Array.from(document.getElementsByClassName("v-modal")).forEach(e=> (<any>e).focus());
    }

    sendChatWithAttachment(file: any): void{
        // console.log({file});

        let message= {
            chatRoomId : this.chatRoom.id,
            senderId: this.currentUserId,
            recieverId: this.currentUserId,
            message: file.name,
            type:'DOCUMENT',
            timeSend: new Date(),
            documentUri: file.url
        }


        this.doSendMessage(message);

        this.openUploadDocument= false;
    }

    downloadChatAttachment(chat): void {
      window.open(chat.documentUri.replace("httpss", "https"), "_blank");
    }
}
